import React from "react"
import { SocialMedia } from "./SocialMedia"
import { GradientContainer } from "./GradientContainer"

export const Footer = () => {
	return (
		<footer className="dark:tw-bg-gray-900 dark:tw-text-white tw-bg-gray-50 tw-border-t tw-border-gray-200 tw-py-8 tw-px-6 tw-text-center">
			<SocialMedia/>
		</footer>
	)		
}
